module.exports = __webpack_public_path__ + "static/media/ao.c8d85e14.svg";